import {Link} from 'react-router';

import Button from '@/shared/components/button';
import {APP_ROUTES} from '@/utils_legacy/routes';

import {CookieConsentInitialProps} from '../types';

const CookieConsentInitial = ({
  onCustomizeSettings,
  onAcceptAll,
}: CookieConsentInitialProps) => {
  return (
    <div
      data-test-id="cookie-consent-modal"
      className="flex max-h-[inherit] flex-col rounded-2lg bg-white px-7 py-8 text-center"
    >
      <h4 className="mb-4 font-semibold text-black text-lg">
        We value your privacy
      </h4>
      <p className="mb-7 text-base">
        We and our partners use tracking devices to measure the audience of our
        website, provide you with offers and advertising tailored to your
        interests, and to enable interactive social platform features such as
        share buttons.&nbsp;
        <Link
          className="font-normal text-system-blue underline"
          to={APP_ROUTES.PrivacyPolicyGroup}
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
        &nbsp;and&nbsp;
        <Link
          className="font-normal text-system-blue underline"
          to={APP_ROUTES.CookiePolicy}
          target="_blank"
          rel="noopener noreferrer"
        >
          Cookie Policy
        </Link>
      </p>
      <div className="flex flex-col gap-3 sm:flex-row">
        <Button onClick={onCustomizeSettings} variant="system">
          Customize settings
        </Button>
        <Button variant="system" onClick={onAcceptAll}>
          Accept all
        </Button>
      </div>
    </div>
  );
};

export default CookieConsentInitial;
